module.exports = __webpack_public_path__ + "static/dinosaur.8913a96c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/dinosaur.jpg
// module id = 61
// module chunks = 82267189633957 139666322020541 248600712657012